/* Blog catalog — instant client-side search over blog cards. */
if (!customElements.get('kb-blog-catalog')) {
  customElements.define(
    'kb-blog-catalog',
    class KbBlogCatalog extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-blogcat-search]');
        this.cards = Array.from(this.querySelectorAll('[data-blogcat-card]'));
        this.empty = this.querySelector('[data-blogcat-empty]');
        if (!this.input) return;
        this.input.addEventListener('input', () => this.filter());
      }
      filter() {
        const q = this.input.value.trim().toLowerCase();
        let shown = 0;
        this.cards.forEach((card) => {
          const match = !q || (card.dataset.title || '').indexOf(q) !== -1;
          card.toggleAttribute('hidden', !match);
          if (match) shown++;
        });
        if (this.empty) this.empty.toggleAttribute('hidden', shown !== 0);
      }
    }
  );
}
